export const UPDATE_FACE_RESULT = 'UPDATE_FACE_RESULT';
export const UPDATE_TONGUE_RESULT = 'UPDATE_TONGUE_RESULT';
export const UPDATE_EXAMINATION_RESULT = 'UPDATE_EXAMINATION_RESULT';

export const updateFaceResultAction = result => ({
  type: UPDATE_FACE_RESULT,
  result,
});

export const updateTongueResultAction = result => ({
  type: UPDATE_TONGUE_RESULT,
  result,
});

export const updateExaminationResultAction = result => ({
  type: UPDATE_EXAMINATION_RESULT,
  result,
});



// WEBPACK FOOTER //
// ./src/actions/result.js